export default "__VITE_ASSET__DpaJZ_c___"